<template>
  <div class="btn-introduction">
    <a
      :href="pdfHref"
      target="_blank">
      <i class="icon-pdf"/>
      導入ご検討の施設の皆様へ
    </a>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'BtnIntroduction',
  components: {
    mapGetters
  },
  data () {
    return {
    }
  },
  computed: {
    ...mapGetters(['textData', 'lang']),
    pdfHref: function () {
      return require('@/assets/pdf/導入ご検討の施設の皆様へ.pdf')
    }
  },
  methods: {
  },
  mounted () {
  },
  created () {
  }
}
</script>

<style lang="postcss" scoped>
  .btn-introduction {
    & a {
      display: inline-block;
      font-size: 14px;
      line-height: 35px;
      width: 100%;
      & .icon-pdf {
        display: inline-block;
        width: 20px;
        height: 22px;
        vertical-align: top;
        margin: 6px 10px 0 17px;
        background: url('~@/assets/img/icon-pdf.png');
        background-size: 20px 22px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/atoms/BtnIntroduction.vue